import { render, staticRenderFns } from "./profileditfirma.vue?vue&type=template&id=17106455&"
import script from "./profileditfirma.vue?vue&type=script&lang=js&"
export * from "./profileditfirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports